import React from 'react';
import Icon from '../shared/Icon';
import { ownerLabel } from './sharedQueries';

/**
 * "Shared with me" group below Saved queries (PRD-1571 R6, Frame 2). Rows are
 * other people's queries: same row markup as Saved queries, the owner's name
 * underneath, and a lock in place of the shared glyph when the viewer can't
 * read the datasets (R11, Frame 3). Rows have no actions: "Remove from my list"
 * was dropped (PRD-1650). Renders nothing while the list is empty.
 */
function SharedWithMeList({ threads, activeThreadId, expanded, onToggle, onSelect }) {
  if (threads.length === 0) return null;
  return (
    <>
      <button
        type="button"
        className="sidebar-nav-item sidebar-saved-header thread-shared-header"
        onClick={onToggle}
        aria-expanded={expanded}
      >
        <Icon name="groups" />
        <span className="sidebar-nav-label">Shared with me</span>
        <Icon name="expand_more" size={18} className={`sidebar-expand-icon ${expanded ? 'expanded' : ''}`} />
      </button>
      {expanded && (
        <div className="thread-items-container">
          {threads.map((thread) => (
            <div
              key={thread.id}
              className={`thread-item ${activeThreadId === thread.id ? 'active' : ''}`}
              onClick={() => onSelect(thread)}
              role="button"
              tabIndex={0}
            >
              <div className="thread-item-content">
                <span className="thread-title">{thread.title || 'Untitled conversation'}</span>
                <span className="thread-owner">{ownerLabel(thread)}</span>
              </div>
              {thread.locked ? (
                <Icon name="lock" size={16} className="thread-shared-glyph" title="You don't have access to this query's datasets" />
              ) : (
                <Icon name="groups" size={16} className="thread-shared-glyph" title="Shared with you" />
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default SharedWithMeList;
